import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'Guía de Pigmentos y Colores',
    value: '15.000 ARS',
    desc: 'Aprende a darle vida a tus piezas con técnicas de marmoleado, colores sólidos y efectos terrazo. Descubre qué pigmentos usar para no alterar la mezcla.',
    image: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/bono_1.png?v=1779992128'
  }, {
    title: 'Manual: Cómo Vender en Instagram',
    value: '20.000 ARS',
    desc: 'Si decides emprender, este manual te enseñará cómo tomar fotos atractivas, poner precios justos y conseguir tus primeros clientes por redes sociales.',
    image: 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/bono_2.png?v=1779992128'
  }];
  return <section className="py-24 bg-white" data-id="element-37">
      <div className="container mx-auto px-4" data-id="element-38">
        <div className="max-w-4xl mx-auto" data-id="element-39">
          <div className="text-center mb-16" data-id="element-40">
            <div className="inline-flex items-center justify-center p-4 bg-sand-100 text-terracotta-500 rounded-full mb-6" data-id="element-41">
              <Gift className="w-6 h-6" data-id="element-42" />
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-concrete-900 mb-4 text-embossed" data-id="element-43">
              Llévate estos{' '}
              <span className="text-metallic-copper italic" data-id="element-44">
                Regalos Exclusivos
              </span>
            </h2>
            <p className="text-lg text-concrete-500 font-light" data-id="element-45">
              Solo si te inscribes el día de hoy
            </p>
          </div>

          <div className="space-y-8" data-id="element-46">
            {bonuses.map((bonus, idx) => <div key={idx} className="bg-sand-50 rounded-[2rem] overflow-hidden shadow-sm border border-sand-200 flex flex-col md:flex-row group hover:shadow-premium transition-shadow duration-500" data-id="element-47">
                <div className="md:w-2/5 bg-white p-6 md:p-8 flex items-center justify-center border-b md:border-b-0 md:border-r border-sand-100 relative overflow-hidden" data-id="element-48">
                  <div className="absolute inset-0 bg-gradient-to-br from-sand-50 to-transparent opacity-50" data-id="element-49"></div>
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain min-h-[200px] max-h-[280px] relative z-10 transform group-hover:scale-105 transition-transform duration-700" data-id="element-50" />
                </div>
                <div className="md:w-3/5 p-8 md:p-12 flex flex-col justify-center" data-id="element-51">
                  <div className="uppercase tracking-widest text-xs text-terracotta-500 font-bold mb-3" data-id="element-52">
                    Bono de Regalo #{idx + 1}
                  </div>
                  <h3 className="text-2xl font-heading font-semibold text-concrete-900 mb-4" data-id="element-53">
                    {bonus.title}
                  </h3>
                  <p className="text-concrete-600 font-light leading-relaxed mb-6" data-id="element-54">
                    {bonus.desc}
                  </p>
                  <div className="mt-auto flex items-center gap-3" data-id="element-55">
                    <span className="text-sm text-concrete-400 line-through" data-id="element-56">
                      Valor: {bonus.value}
                    </span>
                    <span className="text-xs font-bold tracking-widest uppercase bg-gold-400/20 text-gold-600 px-3 py-1 rounded-full" data-id="element-57">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}